export default __webpack_public_path__ + "static/logo-color-7e7cb9ab128dfcd38b560269f89bb8d9.svg";